<template>
  <div ref="domRef" :class="['base-card-info', marginBottom ? 'mb-0' : '']">
    <div class="info-card-title">
      {{ companyTypeText }}信息
    </div>
    <div class="custom-base-info">
      <div class="item">
        <div class="label">
          身份证人像面
        </div>
        <div class="value">
          <div class="id-card-box">
            <img :src="baseInfo.companyLegal?.idNoFrontUrl">
          </div>
        </div>
      </div>
      <div class="item">
        <div class="label">
          身份证国徽面
        </div>
        <div class="value">
          <div class="id-card-box">
            <img :src="baseInfo.companyLegal?.idNoBackUrl">
          </div>
        </div>
      </div>
      <div class="item">
        <div class="label" />
        <div class="value" />
      </div>
      <div class="item">
        <div class="label">
          {{ isCompanyType ? '法定代表人' : companyTypeText }}姓名
        </div>
        <div class="value">
          {{ baseInfo.companyLegal?.legalName }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          {{ isCompanyType ? '法定代表人' : `${companyTypeText || ''}身份` }}证件号
        </div>
        <div class="value">
          {{ baseInfo.companyLegal?.legalIdNo }}
        </div>
      </div>
      <div class="item">
        <div class="label" />
        <div class="value" />
      </div>
      <div class="item">
        <div class="label">
          {{ isCompanyType ? '法定代表人' : companyTypeText }}{{ isCompanyType ? '' : '联系' }}电话
        </div>
        <div class="value">
          {{ baseInfo.companyLegal?.legalPhone }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          证件有效期
        </div>
        <div class="value">
          <span>{{ baseInfo.companyLegal?.idNoExpiryStartDate }}</span>
          <span> ~ </span>
          <span>{{ baseInfo.companyLegal?.idNoExpiryEndDate }}&nbsp;&nbsp;</span>
          <span v-if="['29991231', '2999-12-31'].includes(baseInfo.companyLegal?.idNoExpiryEndDate)">长期</span>
        </div>
      </div>
      <div class="item">
        <div class="label" />
        <div class="value" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ECompanyType, ICompanyMergeInfo } from '@core/main/types';
import { useElementImgPreview } from '@vue3/components';
import { inject, ref, watch } from 'vue';

defineOptions({ name: 'LegalPersonInfo' }); // 账户中心 - 法人信息

const domRef = ref<HTMLDivElement>();

const baseInfo = ref(inject('baseInfo') as ICompanyMergeInfo);

const isCompanyType = ref(false);
const companyTypeText = ref<string>();

useElementImgPreview(domRef);

defineProps({
  marginBottom: {
    type: Boolean,
    default: false,
  },
});

watch(() => baseInfo.value.companyBase?.type,
  (newV) => {
    if (newV) {
      isCompanyType.value = newV === ECompanyType.Company;
      companyTypeText.value = isCompanyType.value ? '法人' : '经营者';
    }
  },
  { immediate: true });
</script>
